import { Badge } from 'react-bootstrap';
import { Link } from 'react-router';
import type { FunctionComponent } from 'react';

import { icons, IconText } from '../../../generic/Icon';
import type { ProjectGroupRelease, ProjectGroupReleaseProject } from '../../../../types';

import styles from './ProjectGroupReleaseProjectsTableHeader.module.less';

type Props = {
  releaseProjects: ProjectGroupReleaseProject[];
  projectGroupId?: number;
  selectedRelease?: ProjectGroupRelease;
};

const ProjectGroupReleaseProjectsTableHeader: FunctionComponent<Props> = ({
  releaseProjects,
  projectGroupId,
  selectedRelease,
}) => {
  const editRedirect = selectedRelease
    ? `/projects/group/${projectGroupId}/releases/${selectedRelease.id}/edit`
    : `/projects/group/${projectGroupId}/releases/`;

  return (
    <div className="card-header">
      <div className={styles.header}>
        <div className={styles.count}>
          Projects In Release{' '}
          <Badge>{releaseProjects.length || 0}</Badge>
        </div>
        <div>
          <Link
            to={editRedirect}
            className="btn btn-default"
            >
            <IconText
              icon={icons.edit}
              text="Edit"
              />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProjectGroupReleaseProjectsTableHeader;
